// Numbers on a product's page worked out from what is already on the device
// (docs/plans/list-fields.md): nothing here is stored.

/** How much was sold since `sinceIso`: sales less returns, from the product's movements. */
export function soldSince(
  movements: { type: string; qty_milli: number; occurred_at: string }[],
  sinceIso: string,
): number {
  let out = 0
  for (const m of movements) {
    if (m.occurred_at < sinceIso) continue
    // A sale takes stock out (negative), a return brings it back (positive).
    if (m.type === 'sale' || m.type === 'sale_return') out -= m.qty_milli
  }
  return Math.max(0, out)
}

/** The moment `days` days before `now`, as an ISO timestamp. */
export function daysAgo(now: Date, days: number): string {
  return new Date(now.getTime() - days * 86_400_000).toISOString()
}

/** A movement's kind for the history list's tile and tabs. */
export type MovementKind = 'sale' | 'received' | 'adjusted'

export function movementKind(type: string): MovementKind {
  if (type === 'sale' || type === 'sale_return') return 'sale'
  if (type === 'receipt' || type === 'opening' || type === 'purchase_return') return 'received'
  return 'adjusted'
}

/** The movement types behind each history tab. */
export const HISTORY_TYPES = {
  sales: ['sale', 'sale_return'],
  received: ['receipt', 'opening', 'purchase_return'],
  adjusted: ['adjustment', 'count', 'transfer_in', 'transfer_out'],
} as const
